import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HelperService } from "../shared/helper.service";
import { Observable } from "rxjs";

@Injectable()
export class CeoReportsService {
  baseUrl: string = environment.api_base_url;

  constructor(public http: HttpClient, private helperService: HelperService) {}

  getSoldInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/reserved_inventory`, qParams);
  }

  getAvaliableInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/available_inventory`, qParams);
  }

  getNotAvaliableInventortyReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/not_available_inventory`,
      qParams
    );
  }

  getDuesInventoryReport(params?) {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/dues_payment`, qParams);
  }

  getDuesPaymentWithSharing(params?): Observable<any> {
    params = this.helperService.removeNullQParams(params);
    return this.helperService.get(
      `ceoReports/dues-payment-with-sharing`,
      params
    );
  }

  getProjectUnitMetrics(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/getProjectUnitMetrics`, qParams);
  }

  getProjectPaymentsSummaryForDev(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/projectPaymentsSummaryForDev`,
      qParams
    );
  }

  getReservedUnitsByDealType(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/getReservedUnitsByDealType`,
      qParams
    );
  }

  getProjectPaymentsSummary(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(`ceoReports/projectPaymentsSummary`, qParams);
  }

  getProjectCostVsBudget(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_project_cost_vs_budget`,
      qParams
    );
  }

  getCheckedProjectCostVsBudget(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_project_cost_vs_budget_checked`,
      qParams
    );
  }

  getActualProjectCostVsBudgetCheckedAllProjects(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_actual_project_cost_vs_budget__checked_all_projects`,
      qParams
    );
  }

  getActualProjectCostVsBudgetAllProject(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_actual_project_cost_vs_budget_v2_all_project`,
      qParams
    );
  }

  getActualProjectCostVsBudgetCheckedAllProjectsV2(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_actual_project_cost_vs_budget_v2__checked_all_projects`,
      qParams
    );
  }

  getProjectBalancesSummary(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_project_balances_summary`,
      qParams
    );
  }

  getCollectionRemainingAmountBalanceReport(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/payment_collection_report`,
      qParams
    );
  }

  getTotalCategoryCostSummary(params) {
    return this.helperService.get(
      `ceoReports/get_total_category_cost_summary`,
      params
    );
  }

  getPayableChequeReport(params?): Observable<any> {
    let qParams = params ? this.helperService.removeNullQParams(params) : {};
    return this.helperService.get(
      `ceoReports/get_payable_cheque_report`,
      qParams
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ceo-reports/ceo-reports.service.ts